<script setup>
import { computed, defineProps } from "vue"
import { useStore, formatPrice } from "./../../utils"

const store = useStore()

const props = defineProps({
  price: [Number, Object],
  compareAtPrice: [Number, Object],
  quantity: {
    type: Number,
    default: 1
  },
  inverted: Boolean
})

const getPriceAsCents = computed(() => {
  return (props.price && props.price.cents) || props.price
})

const getCompareAtPriceAsCents = computed(() => {
  return (
    (props.compareAtPrice && props.compareAtPrice.cents) || props.compareAtPrice
  )
})

const getHasValidCompareAtPrice = computed(() => {
  return getCompareAtPriceAsCents.value > getPriceAsCents.value
})

const getDefaultPrice = computed(() => {
  // If there is a 'compareAtPrice', that should be the 'default' price against which the adjusted price is compared; otherwise just use the price.
  if (
    getCompareAtPriceAsCents.value &&
    getCompareAtPriceAsCents.value > getPriceAsCents.value
  ) {
    return formatPrice(
      getCompareAtPriceAsCents.value,
      store.state.locale.localeConfig,
      props.quantity
    )
  } else {
    return formatPrice(
      getPriceAsCents.value,
      store.state.locale.localeConfig,
      props.quantity
    )
  }
})

const getAdjustedPrice = computed(() => {
  return formatPrice(
    getPriceAsCents.value,
    store.state.locale.localeConfig,
    props.quantity
  )
})
</script>

<template>
  <span class="price-renderer">
    <span
      :class="{
        'price-renderer__default-price--strikethrough': getHasValidCompareAtPrice,
        'price-renderer__default-price--strikethrough--inverted':
          getHasValidCompareAtPrice && inverted
      }"
      class="price-renderer__default-price"
    >
      {{ getDefaultPrice }}
    </span>
    <span
      v-if="getHasValidCompareAtPrice"
      :class="inverted ? 'text--clr-purple' : 'text--clr-purple_dark'"
    >
      {{ getAdjustedPrice }}
    </span>
  </span>
</template>

<style lang="scss">
.price-renderer {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  color: inherit;

  &__default-price {
    position: relative;
    margin-right: 0.2em;
    &--strikethrough {
      color: getcolour(bleach_grey_60);
      &:after {
        content: "";
        position: absolute;
        width: 90%;
        height: 1.25px;
        top: 50%;
        left: calc(50% - 0.2em);
        transform-origin: center;
        transform: translate(-50%, 0) rotate(-10deg);
        background-color: getcolour(bleach_purple_dark);
      }

      &--inverted {
        color: getcolour(bleach_grey_40);
        &:after {
          background-color: getcolour(bleach_grey_80);
        }
      }
    }
  }
}
</style>
